export enum SecType {
    Web = 'WEB',
    Ccd = 'CCD',
    Ppd = 'PPD',
    Tel = 'TEL'
}



// WEBPACK FOOTER //
// ./src/app/customerservice/enums/payment-ach-sectypes.enum.ts